import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from '../Components/SideBar';

const MainLayout = ({ totalnewOrder }) => {
    const [collapsed, setCollapsed] = useState(true);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    const location = useLocation();

    // Check if current path is /login
    const isLoginPage = ["/login", "/reset","/home/login"].includes(location.pathname);

    useEffect(() => {
        document.body.classList.toggle("sidebar-mobile-open", mobileOpen && isMobile);
        return () => document.body.classList.remove("sidebar-mobile-open");
    }, [mobileOpen, isMobile]);

    useEffect(() => {
        const isMobile = window.innerWidth < 1024;
        if (isMobile) {
            setCollapsed(false);
            setMobileOpen(false);
        } else {
            setCollapsed(true);
            setMobileOpen(false);
        }

        const handleResize = () => {
            const nowMobile = window.innerWidth < 1024;

            setCollapsed((prev) => {
                if (nowMobile && prev !== false) return false;
                if (!nowMobile && prev !== true) return true;
                return prev;
            });

            setMobileOpen((prev) => {
                if (!nowMobile && prev) return false;
                return prev;
            });
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const closeMobileMenu = () => setMobileOpen(false);

    const sidebarWidth = isMobile
        ? 0
        : collapsed
            ? 64
            : 240;

    // Hide sidebar & padding on /login
    if (isLoginPage) {
        return (
            <div className="admin-app-shell min-h-screen">
                <Outlet />
            </div>
        );
    }

    return (
        <div className="admin-app-shell min-h-screen">
            {/* Sidebar */}
            <Sidebar
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                mobileOpen={mobileOpen}
                setMobileOpen={setMobileOpen}
                isMobile={isMobile}
                onCloseMobile={closeMobileMenu}
                totalnewOrder={totalnewOrder}
            />

            {/* Content Area */}
            <main
                className={`
                    transition-all duration-300 ease-in-out
                    ${isMobile ? "w-full" : ""}
                `}
                style={{
                    marginLeft: isMobile ? 0 : `${sidebarWidth}px`,
                    pointerEvents: mobileOpen && isMobile ? "none" : "auto",
                }}
                onClick={isMobile ? closeMobileMenu : undefined}
            >
                <div className="p-2 md:p-4">
                    <Outlet key={location.key} />
                    <span className="admin-page-bottom-span" aria-hidden="true" />
                </div>
            </main>

            {/* Mobile Overlay */}
            {mobileOpen && isMobile && (
                <div
                    className="fixed inset-0 bg-black/50 z-40"
                    onClick={closeMobileMenu}
                />
            )}
        </div>
    );
};

export default MainLayout;